import AppAdminSponsorsCtrl from './get';
import appAdminSponsorsTemplate from './get/template.html';
import AppAdminSponsorsSponsorCtrl from './edit';
import appAdminSponsorsSponsorTemplate from './edit/template.html';

const appAdminSponsors = {
  url: '/sponsors-manager',
  stateName: 'Sponsor Manager',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app': {
      template: appAdminSponsorsTemplate,
      controller: AppAdminSponsorsCtrl,
      controllerAs: 'sponsorsCtrl'
    }
  }
};

const appAdminSponsorsSponsor = {
  url: '/:sponsor_id?tour',
  stateName: 'Sponsor Editor',
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/admin/sponsors-manager')
  },
  views: {
    'a@app': {
      template: appAdminSponsorsSponsorTemplate,
      controller: AppAdminSponsorsSponsorCtrl,
      controllerAs: 'sponsorCtrl'
    }
  }
};

export { appAdminSponsors, appAdminSponsorsSponsor };



// WEBPACK FOOTER //
// ./src/app/controllers/admin/sponsors/index.js